import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';

class NotificationService {
  /**
   * Upload the device token to the dedicated broadcast API.
   * Pattern: Kiosk Project
   */
  async uploadDeviceToken(userId, token, countryCode) {
    if (!userId || !token) return;

    const requestId = `req_${Date.now().toString(36)}${Math.floor(Math.random() * 100000)}`;

    const payload = {
      requestId,
      emitter: 'kingrecharges',
      userId: userId,
      token: token
    };

    if (countryCode && countryCode !== 'ANY') {
      payload.metadata = {
        country: countryCode
      };
    }

    console.log('[NotificationService] Uploading device token...', payload);

    bus.emit('network.request', {
      id: requestId,
      url: constants.ENDPOINTS.SERVICES.ADD_TOKEN,
      method: 'POST',
      data: payload
    });
  }
}

export const notificationService = new NotificationService();
